// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__qIOs2","emails":"CreateEditClinics_emails__Te2AG","emailTagLabel":"CreateEditClinics_emailTagLabel__-ggHe"};